import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import clsx from 'clsx';

import { Game } from 'modules/lobby-page/pages/lobby';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { coinIcons } from 'shared/constants';
import { useAccount } from 'shared/hooks/use-web3';
import { useCurrenciesStore } from 'shared/store/currenciesStore';
import { useGlobalStore } from 'shared/store/globalStore';
import { prettyTx } from 'shared/utils/pretty-tx';

import EyeIcon from 'assets/eye.svg?react';
import WatchGameIcon from 'assets/png/replay.png?format=webp;avif&as=picture';

interface IWatchGameItemProps {
  game: Game;
}

export const WatchGameItemMobile = ({ game }: IWatchGameItemProps) => {
  const navigate = useNavigate();
  const { chainId } = useAccount();
  const { leaderboardMap } = useGlobalStore();
  const { availableCurrencies } = useCurrenciesStore();

  const { t } = useTranslation();
  const containerRef = useRef(null);
  const currency = availableCurrencies.find(
    (currency) => currency.address.toLowerCase() === game[3].toLowerCase(),
  );

  const normalizedAmount = game[4];

  const playerA = useMemo(() => {
    return prettyTx({
      address: game[1],
      leaderboardMap: leaderboardMap,
      startAddressLength: 2,
      endAddressLength: 4,
      discordUsernameLength: 9,
    });
  }, [game, leaderboardMap]);
  const playerB = useMemo(() => {
    return prettyTx({
      address: game[2],
      leaderboardMap: leaderboardMap,
      startAddressLength: 2,
      endAddressLength: 4,
      discordUsernameLength: 9,
    });
  }, [game, leaderboardMap]);
  return (
    <div ref={containerRef} className="w-full">
      <div className="grid grid-cols-[2fr_1fr_1fr_1.5fr] rounded-lg border border-[rgba(255,255,255,0.25)] bg-gradient-to-r p-0.5 pr-2 transition-all sm:rounded-xl sm:border-2">
        <div className="items flex items-center gap-1">
          <OptimizedImage imageData={WatchGameIcon} alt="short" className="h-7 w-7" />
          <div className="flex flex-col">
            <span
              className={clsx(
                'font-chivo text-[8px] font-medium leading-none text-yellow sm:text-[20px]',
              )}
            >
              {playerA}
            </span>
            <span className="pl-4 text-[9px] font-medium leading-none text-white opacity-75 sm:text-[14px]">
              {t('common.vs')}
            </span>
            <span
              className={clsx(
                'font-chivo text-[8px] font-medium leading-none text-[#4FB5FF] sm:text-[20px]',
              )}
            >
              {playerB}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-center gap-1">
          {currency?.symbol ? (
            <img
              src={coinIcons[currency.symbol as keyof typeof coinIcons]}
              alt="coin"
              className="h-[18px] w-[18px]"
            />
          ) : null}
          <div>
            <p className="text-[10px] font-semibold leading-[10px] text-white">
              {parseFloat(normalizedAmount).toFixed(2)}
            </p>

            <p className="text-[10px] font-semibold text-white opacity-75">{currency?.symbol}</p>
          </div>
        </div>

        <div className="relative flex items-center justify-center gap-2">
          {/* hidden while we do not have this games from api */}
          {/* <OptimizedImage imageData={Heart} alt="heart" className="h-7 w-7" /> */}
          {/* <OptimizedImage
                        imageData={Heart}
                        alt="heart"
                        className={`h-7 w-7 ${wins > 3 ? 'opacity-50' : ''}`}
                    /> */}

          {/* {wins !== 3 && wins > 0 && (
                        <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[36px] font-semibold leading-none text-white">
                            {wins}
                        </span>
                    )} */}
          {/* <OptimizedImage imageData={Heart} alt="heart" className="h-7 w-7" /> */}
        </div>
        <div className="flex items-center justify-end">
          <button
            className={`flex min-w-[60px] items-center justify-end gap-0.5 text-sm font-extrabold uppercase`}
            onClick={() => {
              navigate(`/stream/${chainId}/${game[0]}`);
            }}
          >
            <EyeIcon className="h-6 w-6 text-[#E89BFF]" />{' '}
            <span className="leading-none text-[#E89BFF]">{t('common.watch')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};
